'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseFetch = require('./baseFetch.js');

var textFetch = function textFetch(url, options) {
  return baseFetch.baseFetch(url, options).then(function (res) {
    return res.text();
  });
};

exports.textFetch = textFetch;
//# sourceMappingURL=textFetch.js.map
